import './App.css';
import Example from './components/Example';

function App() {
  return (
    <Example />
    
    
  );
}


export default App;